(function () {
  angular.module('MktzapApp.Controllers')
    .controller('GeneralSettingsController', generalSettings);

  generalSettings.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'LocalStorageService'];

  function generalSettings ($http, $state, AuthenticationService, $rootScope, LocalStorageService) {
    if (LocalStorageService.checkInPause()) {
      LocalStorageService.sendToBlockPage();
    }

    var vmGeneralCtrl = this;
    vmGeneralCtrl.TAB_NOTIFICATIONS = 1;
    vmGeneralCtrl.TAB_CONTROL_PAUSE = 2;
    vmGeneralCtrl.TAB_CARD_SETTINGS = 3;
    vmGeneralCtrl.TAB_DASHBOARD_SETTINGS = 4;
    vmGeneralCtrl.TAB_SECURITY = 5;
    vmGeneralCtrl.TAB_ACTIVE_SENDER = 6;
    vmGeneralCtrl.TAB_NOTIFICATIONS_TRACKER = 7;
    vmGeneralCtrl.TAB_CP_SETTINGS = 8;
    vmGeneralCtrl.TAB_READ_UNREAD = 9;
    vmGeneralCtrl.TAB_CAMPAIGN = 10;
    vmGeneralCtrl.TAB_CUSTOM_DOCUMENTS = 11;
    vmGeneralCtrl.TAB_FORMALIZATION_PROPOSAL_STATUS = 12;
    vmGeneralCtrl.TAB_MESSAGES_PORTAL = 13;
    vmGeneralCtrl.TAB_EXCLUSIVE_ACTIONS = 14;
    vmGeneralCtrl.TAB_AUTOMATIC_ANSWERS = 15;
    vmGeneralCtrl.TAB_KNOWLEDGE_BASE = 16;
    vmGeneralCtrl.TAB_LOGIN_SETTINGS = 17;
    vmGeneralCtrl.TAB_HISTORY_SETTINGS = 18;
    vmGeneralCtrl.TAB_FORMALIZATION = 19;
    vmGeneralCtrl.TAB_SUPPORTED_MEDIAS = 20;
    vmGeneralCtrl.TAB_COMPANY_EMPLOYER = 21;
    vmGeneralCtrl.TAB_NPS_SURVEY = 22;
    vmGeneralCtrl.TAB_COMPANY_INSURANCE = 23;
    vmGeneralCtrl.TAB_B2B_TELESAQUE_SENDING_PROPOSAL = 24;
    vmGeneralCtrl.TAB_PARTNER_COMPANIES = 25;
    vmGeneralCtrl.tab = vmGeneralCtrl.TAB_NOTIFICATIONS;

    // Define se o Usuáio logado pode ou não ver a tela
    vmGeneralCtrl.canShow = $rootScope.checkMenuAccess('settings.generalSettings');

    vmGeneralCtrl.changeTab = function (tab) {
      vmGeneralCtrl.tab = tab;
    };
    vmGeneralCtrl.setActiveTab = function (tab) {
      if (vmGeneralCtrl.tab == tab) {
        return 'primary';
      } else {
        return 'secondary';
      }
    };
  }
})();
